import { create, ZoidComponent } from 'zoid/dist/zoid.frameworks'
import { commonComponentsProps } from '../../common/props'

import defaultLoader from '../../common/defaultLoaderTemplate'
import simpleContainerTemplate from '../../common/simpleContainerTemplate'

const cdc: ZoidComponent = create({
  tag: 'mbo-cdc-dashboard-learn-and-grow-your-business',

  url:
    import.meta.env.VITE_VUE_URL + '/#/dashboard/learn-and-grow-your-business',

  context: 'iframe',

  dimensions: {
    width: '100%',
    height: '100%',
  },

  autoResize: {
    width: false,
    height: true,
  },

  containerTemplate: simpleContainerTemplate,

  prerenderTemplate: defaultLoader,

  props: {
    ...commonComponentsProps,
  },
})

export default cdc
